import React, { useEffect, Suspense } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import './i18n';
import './App.scss';
import Router from './Router';
import GlobalStyle from './globalStyles';
import { selectUserUuid, setUserToken, setUuid } from './features/signup/signupSlice';
import { setWebp } from './features/ui/uiSlice';
import Loader from './UI/Loader';
import UIAlert from './UI/Alert';
import * as Sentry from '@sentry/react';
import useInlineScript from './helper/useInlineScript';
import AF from './scripts/appsflyer';
import useBackgroundSrc from './helper/useBackgroundSrc';
import { appendLinkOnLoad, canUseWebp } from './helper/utils';
import useWindowWidth from './helper/useWindowWidth';
import { browserName, isIOS, osVersion } from 'react-device-detect';
import oneLinkSmartScript from './scripts/oneLink';
import FacebookPixel from 'react-facebook-pixel';
import { FB_PIXEL_ID } from './analytics/facebook';
import RedditPixel from 'react-reddit-pixel';
import ReactGA from 'react-ga4';
import { REACT_APP_GOOGLE_TRACKING_ID } from './analytics/GA';

const StyledWrapper = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto; 
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  background: ${props => (props.windowWidth <= 430 && browserName === 'Facebook') ? 'linear-gradient(170.11deg, #3673B0 0%, #BD98B2 73.45%)' : 'none'};
`;


function App() {
    const dispatch = useDispatch();
    const userUuid = useSelector(selectUserUuid);
    const windowWidth = useWindowWidth();
    const { backgroundSources } = useBackgroundSrc();

    useInlineScript(AF, 'AppsFlyerSdkObject');
    useInlineScript(oneLinkSmartScript, 'AF_SMART_SCRIPT');

    useEffect(() => {
        const storageToken = window.sessionStorage?.getItem('access_token');

        if (storageToken) {
            dispatch(setUserToken(storageToken))
        }

        dispatch(setUuid());
    }, [dispatch]);

    useEffect(() => {
        if (!userUuid) return;
        FacebookPixel.init(FB_PIXEL_ID,{'external_id': userUuid});
        FacebookPixel.pageView();

        RedditPixel.init('t2_w1gr13ev',{"optOut":false,"useDecimalCurrencyValues":true,"externalId":userUuid});
        RedditPixel.pageVisit();
    }, [userUuid]);

    useEffect(() => {
        REACT_APP_GOOGLE_TRACKING_ID && ReactGA.initialize(REACT_APP_GOOGLE_TRACKING_ID);
    },[]);

    /*useEffect(() => {
        setTimeout(() => {
            const setDynamicVH = () => {
                let vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--vh', `${vh}px`);
            };
            setDynamicVH();
            window.addEventListener('resize', () => setDynamicVH(), false);
        },1000);
    }, []);*/

    useEffect(() => {
        dispatch(setWebp(isIOS && osVersion < 14 ? false : canUseWebp()));
        appendLinkOnLoad(`${backgroundSources.welcome}`, 'preload').then(() => {
          return appendLinkOnLoad(`${backgroundSources.two}`)
      })
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [dispatch]);

    return (
        <Suspense fallback={<Loader suspenseShow={true}/>}>
            <StyledWrapper windowWidth={windowWidth}>
                <GlobalStyle/>
                <Loader showMessage={true}/>
                <BrowserRouter>
                    <Route path={['/']} component={Router}/>
                </BrowserRouter>
                <UIAlert/>
            </StyledWrapper>
        </Suspense>
    )
}

export default Sentry.withProfiler(App);
